import { Box, Stack } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { plans } from "../../../lib/data/plans";

SwiperCore.use([Autoplay, Navigation, Pagination]);

export default function Events() {
  return (
    <div className={"events-frame"}>
      <Stack className={"events-main"}>
        <Box className={"events-text"}>
          <span className={"category-title"}>Join our Events</span>
        </Box>

        <Swiper
          className={"events-info"}
          slidesPerView={"auto"}
          centeredSlides={true}
          spaceBetween={28}
          loop={true}
          navigation={{
            nextEl: ".events-frame .swiper-button-next",
            prevEl: ".events-frame .swiper-button-prev",
          }}
          pagination={{
            el: ".events-frame .swiper-pagination",
            clickable: true,
          }}
          autoplay={{
            delay: 2800,
            disableOnInteraction: true,
          }}
        >
          {plans.map((value, number) => (
            <SwiperSlide key={number} className={"events-info-frame"}>
              <div className={"event-card"}>
                <div
                  className={"event-card-img"}
                  style={{ backgroundImage: `url(${value.img})` }}
                />
                <Box className={"events-desc"}>
                  <strong className="event-card-title">{value.title}</strong>
                  <div className="event-organizator">
                    <PersonOutlineIcon sx={{ fontSize: 18 }} />
                    <span className="spec-text-author">{value.author}</span>
                  </div>
                  <p className="text-desc">{value.desc}</p>
                  <div className="bott-info">
                    <div className="bott-info-main">
                      <CalendarTodayOutlinedIcon sx={{ fontSize: 15 }} />
                      {value.date}
                    </div>
                    <div className="bott-info-main">
                      <PlaceOutlinedIcon sx={{ fontSize: 16 }} />
                      {value.location}
                    </div>
                  </div>
                </Box>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <Box className={"prev-next-frame"}>
          <img
            src={"/icons/arrow-right.svg"}
            className={"swiper-button-prev"}
            alt="prev"
          />
          <div className={"dot-frame-pagination swiper-pagination"}></div>
          <img
            src={"/icons/arrow-right.svg"}
            className={"swiper-button-next"}
            style={{ transform: "rotate(-180deg)" }}
            alt="next"
          />
        </Box>
      </Stack>
    </div>
  );
}
